import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"

// Connects to data-controller="left-menu"
export default class extends Controller {
  toggle(event) {
    const isCollapsed = this.element.dataset.collapsed === "true"
    const newValue = !isCollapsed
    this.element.dataset.collapsed = newValue

    this.closeAllSubmenus()

    if (event.type === "click") {
      this.saveToggle(newValue)
    }
  }

  toggleItem(event) {
    event.preventDefault()
    event.stopPropagation()

    const item = event.currentTarget.closest(".nav-item")
    const isOpen = item.classList.contains("submenu-open")

    if (isOpen) {
      this.closeSubmenu(item)
    } else {
      this.openSubmenu(item)
    }
  }

  openSubmenu(item) {
    // Close all other submenus first
    const allItems = this.element.querySelectorAll(".nav-item")
    allItems.forEach((otherItem) => {
      if (otherItem !== item) {
        this.closeSubmenu(otherItem)
      }
    })

    item.classList.add("submenu-open")
    const button = item.querySelector("button[data-action*='toggleItem']")
    if (button) {
      button.setAttribute("aria-expanded", "true")
    }
  }

  closeSubmenu(item) {
    item.classList.remove("submenu-open")
    const button = item.querySelector("button[data-action*='toggleItem']")
    if (button) {
      button.setAttribute("aria-expanded", "false")
    }
  }

  openSubmenuOnHover(event) {
    const item = event.currentTarget
    this.openSubmenu(item)
  }

  maybeCloseSubmenu(event) {
    const item = event.currentTarget
    const toEl = event.relatedTarget
    // Don't close if we're moving to a child element
    if (toEl && item.contains(toEl)) return
    this.closeSubmenu(item)
  }

  closeAllSubmenus() {
    const allItems = this.element.querySelectorAll(".nav-item.submenu-open")
    allItems.forEach((item) => {
      item.classList.remove("submenu-open")
      const button = item.querySelector("button[data-action*='toggleItem']")
      if (button) {
        button.setAttribute("aria-expanded", "false")
      }
    })
  }

  saveToggle(value) {
    void patch(`/left_navigation_menu/${value}`)
  }

  get menuElement() {
    return document.getElementById("left-navigation-menu") || this.element
  }

  openNav() {
    this.menuElement.classList.remove("-translate-x-full")
    this.menuElement.classList.add("translate-x-0")
  }

  closeNav() {
    this.menuElement.classList.remove("translate-x-0")
    this.menuElement.classList.add("-translate-x-full")
  }

  handleBeforeCache() {
    this.closeNav()
    this.closeAllSubmenus()
  }
}
